'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../');

var _reactChildrenUtilities = require('react-children-utilities');

var _reactChildrenUtilities2 = _interopRequireDefault(_reactChildrenUtilities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxGroup = function (_Component) {
  _inherits(CheckboxGroup, _Component);

  function CheckboxGroup() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CheckboxGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: _this.props.value || _this.props.defaultValue || []
    }, _this.onCheckboxChange = function (checked, checkboxValue) {
      var currentGroupValue = _this.state.value;
      var _this$props = _this.props,
          value = _this$props.value,
          onChange = _this$props.onChange;


      var newGroupValue = checked ? [].concat(_toConsumableArray(currentGroupValue), [checkboxValue]) : currentGroupValue.filter(function (v) {
        return v !== checkboxValue;
      });

      _this.setState({ value: value || newGroupValue });

      if (onChange) {
        onChange(newGroupValue);
      }
    }, _this.renderChildren = function () {
      var _this$props2 = _this.props,
          inline = _this$props2.inline,
          children = _this$props2.children,
          name = _this$props2.name;

      var newProps = {
        name: name,
        checkedValues: _this.state.value,
        onChange: _this.onCheckboxChange
      };
      return _react2.default.createElement(
        _.Group,
        { selection: true, inline: inline },
        _reactChildrenUtilities2.default.deepMap(children, function (child) {
          return child.type === _.Checkbox ? _react2.default.cloneElement(child, newProps) : child;
        })
      );
    }, _this.componentWillReceiveProps = function (newProps) {
      if (newProps.value) {
        _this.setState({
          value: newProps.value
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CheckboxGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          labelClassName = _props.labelClassName,
          label = _props.label;

      return _react2.default.createElement(
        'div',
        { className: 'luna-form__field' },
        label && _react2.default.createElement(
          'label',
          { className: 'luna-label ' + labelClassName },
          _react2.default.createElement(
            'strong',
            null,
            label
          )
        ),
        this.renderChildren()
      );
    }
  }]);

  return CheckboxGroup;
}(_react.Component);

CheckboxGroup.propTypes = {
  labelClassName: _propTypes2.default.string,
  name: _propTypes2.default.string,
  defaultValue: _propTypes2.default.array,
  value: _propTypes2.default.array,
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.node.isRequired,
  label: _propTypes2.default.string,
  inline: _propTypes2.default.bool
};
CheckboxGroup.defaultProps = {
  labelClassName: ''
};
exports.default = CheckboxGroup;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/CheckboxGroup/CheckboxGroup.js